// extracted by mini-css-extract-plugin
export var termsAndConditionsWrapper = "TermsAndConditions_termsAndConditionsWrapper__wJWuj";